import {
  FaClosedCaptioning,
  FaCode,
  FaCogs,
  FaDatabase,
  FaDownload,
  FaFileVideo,
  FaImage,
  FaLightbulb,
  FaMagic,
  FaPlayCircle,
  FaPuzzlePiece,
  FaRocket,
} from 'react-icons/fa';
import './index.less';

import Jianying from '../Jianying';

const pluginsData = [
  {
    name: '视频快剪',
    icon: <FaPlayCircle />,
    description: '一键合成视频与图片，添加BGM、配音、转场、贴纸，轻松成片',
  },
  {
    name: '图生视频',
    icon: <FaMagic />,
    description: '包含豆包、海螺、vidu、万相、可灵即梦等图片生成视频技术，激发创意',
  },
  {
    name: '字幕同步',
    icon: <FaClosedCaptioning />,
    description: '智能校准字幕与音频，打造专业视听体验',
  },
  {
    name: '音频提取',
    icon: <FaCode />,
    description: '快速提取视频音频，支持多格式输出，获取纯净音频',
  },
  {
    name: '声音克隆',
    icon: <FaImage />,
    description: '克隆专属声音，用于配音等，赋予作品独特魅力',
  },
  {
    name: '视频搜索',
    icon: <FaFileVideo />,
    description: '搜索抖音、快手、小红书、B站等平台视频搜索，轻松获取创作素材',
  },
  {
    name: '视频下载',
    icon: <FaDownload />,
    description: '下载抖音、快手、小红书、B站等平台视频，丰富创作资源',
  },
  {
    name: '数据洞察',
    icon: <FaDatabase />,
    description:
      '连接淘宝、京东、拼多多、抖音、快手、小红书、B站等各大平台，获取丰富数据，助力创作决策。',
  },
];

const workflowSteps = [
  {
    title: '定义任务',
    description: '明确您的自动化需求',
    icon: <FaLightbulb />,
  },
  {
    title: '组合插件',
    description: '选择并配置所需插件',
    icon: <FaPuzzlePiece />,
  },
  {
    title: '配置工作流',
    description: '设置执行逻辑与顺序',
    icon: <FaCogs />,
  },
  {
    title: '部署运行',
    description: '监控与优化执行效果',
    icon: <FaRocket />,
  },
];

const PluginsSection = () => {
  return (
    <section className="plugins-section">
      <div className="container">
        <Jianying />
        <div className="text-center mb-5">
          <h2 className="section-title">丰富的插件和工作流</h2>
          <p className="section-subtitle">
            汇聚 180 + 核心插件，800 + 工作流，可充分满足企业级 AI Agent
            调用，支持企业与个人按需订阅。
          </p>
        </div>
        <div className="plugins-grid">
          {pluginsData.map((plugin, index) => (
            <div className="plugin-card" key={index}>
              <div className="plugin-icon-home">{plugin.icon}</div>
              <h3 className="plugin-title">{plugin.name}</h3>
              <p className="plugin-description">{plugin.description}</p>
            </div>
          ))}
        </div>

        <div className="workflow-section">
          <div className="text-center">
            <h2 className="section-title">智能工作流程</h2>
            <p className="section-subtitle">四步构建强大的自动化工作流</p>
          </div>

          <div className="workflow-steps">
            {workflowSteps.map((step, index) => (
              <div className="workflow-step" key={index}>
                <div className="step-icon">{step.icon}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-desc">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PluginsSection;
